import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type HelpButtonProps = {
  id: string;
  referenceId: string;
  onClick: () => void;
};

export function HelpButton({ id, referenceId, onClick }: HelpButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      id={`${id}-help-button`}
      aria-labelledby={`${referenceId} ${id}-help`}
      className="transparent-button wtf"
      onClick={onClick}
    >
      <span id={`${id}-help`} hidden>
        {t('generic.button.help')}
      </span>
      <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" onClick={onClick} />
    </button>
  );
}
